/**
 * Accordion component - Expandable content
 */

import {useState, ReactNode} from 'react';
import {cn} from '../../utils/cn';

interface AccordionItemProps {
  question: string;
  answer: string | ReactNode;
  defaultOpen?: boolean;
}

export function AccordionItem({question, answer, defaultOpen = false}: AccordionItemProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="bg-background dark:bg-[#252526] border border-border dark:border-gray-700 rounded-lg overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-backgroundSecondary dark:hover:bg-[#2D2D30] transition-colors"
      >
        <span className="font-semibold text-textPrimary dark:text-[#CCCCCC]">{question}</span>
        <span className="text-textSecondary dark:text-[#858585] text-xl">
          {isOpen ? '−' : '+'}
        </span>
      </button>
      {isOpen && (
        <div className="px-6 pb-4 text-textSecondary dark:text-[#858585] leading-relaxed animate-fade-in">
          {answer}
        </div>
      )}
    </div>
  );
}

interface AccordionProps {
  items: AccordionItemProps[];
  className?: string;
}

export function Accordion({items, className}: AccordionProps) {
  return (
    <div className={cn('space-y-4', className)}>
      {items.map((item, index) => (
        <AccordionItem key={index} {...item} />
      ))}
    </div>
  );
}

